import { requestTool } from "../tools";

const login = (data, url) => {
    return requestTool.postRequest(url + "/api/token/get-token", data);
}

const sendResetPasswordLink = (data, url) =>
    requestTool.postRequest(url + "/api/token/reset-password/", data);

const changePassword = (data, url) =>
    requestTool.postRequest(url + "/api/token/change-password/", data);

const getLdapDomains = (url, data) => {
    return requestTool.postRequest(url + "/api/token/get-filtered-settings", data);
}
const getOtpToken = (data, url) => {
    return requestTool.postRequest(url + "?_username=" + data.username);
}

const getOtpTokenValidate = (data, url) => {
    return requestTool.postRequest(url, data);
}


export const authenticationService = { login, sendResetPasswordLink, changePassword, getLdapDomains, getOtpToken, getOtpTokenValidate };

export default authenticationService;

